export const isB2CHost = () =>
  /^flights?discounts?\./i.test(window.location.hostname) ||
  sessionStorage.getItem("sv_force_b2c_host") === "1";

export const b2cBase = () => (isB2CHost() ? "" : "/flights");

export const b2cPath = (p = "") => `${b2cBase()}${p}` || "/";

export const mainSiteUrl = () =>
  isB2CHost() ? `https://${window.location.hostname.replace(/^flights?discounts?\./i, "")}` : "/";
